import React from "react";
import MaskedInput from "react-text-mask";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlPhoneProps extends ControlTemplateProps {

}

export const CreateTextMaskCustom = (mask: Array<string | RegExp>) => {
    const TextMaskCustom = React.forwardRef<HTMLInputElement, any>((props, ref) => {
        return (
            <MaskedInput
                {...props}
                mask={mask}
                showMask
                placeholderChar={"\u2000"}
                guide={false}
                ref={(maskedInputRef: any) => {
                    const inputElement: HTMLInputElement | null =
                        maskedInputRef?.inputElement ?? null;

                    if (typeof ref === "function") {
                        ref(inputElement);
                    } else if (ref) {
                        (ref as React.MutableRefObject<HTMLInputElement | null>).current =
                            inputElement;
                    }
                }}
            />
        );
    });

    TextMaskCustom.displayName = "TextMaskCustom";

    return TextMaskCustom;
};

const maskedPhoneField = CreateTextMaskCustom(
    [
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ],
);

export const ControlPhone: React.FC<ControlPhoneProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    return (
        <ControlInput type="tel"
            {...ComponentProps(props)}
            style={{ ...styles.phone ?? styles.text ?? styles.input, ...props.style }}
            tag={maskedPhoneField}
            onKeyDown={(e: any) => {
                let cursorPos = Number(e.target.selectionStart);
                let keyCode = Number(e.keyCode);
                if (
                    (cursorPos === 5 || cursorPos === 6 || cursorPos === 10) &&
                    keyCode === 8
                ) {
                    e.preventDefault();
                    e.target.value = e.target.value.substring(
                        0,
                        e.target.value.length - 1
                    );
                }
            }}
        />
    );
};